import { FC } from 'react';

type ExternaLinkProps = {
  url: string;
  text: string;
};

export const ExternalLink: FC<ExternaLinkProps> = ({ url, text }) => (
  <a className="link-emphasis" href={url} target="_blank" rel="noopener noreferrer">{text}</a>
);
